import "reflect-metadata";
import {injectable} from "inversify";
import api, {parseServerError, processBlobErrorResponse} from "@dropDesk/data/clients/http.client";
import {
    ReportTicketComparativeEntity
} from "@dropDesk/domain/entities/reports/report_ticket_comparative/report_ticket_comparative.entity";
import {downloadFile, openFileInNewTab} from "@dropDesk/utils/helpers/files";
import {ReportEntityFilters} from "@dropDesk/presentation/components/filters/report_entity_filters";

@injectable()
export abstract class ReportTicketComparativeRemoteDataSource {
    public abstract get(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<ReportTicketComparativeEntity>;

    public abstract exportHtml(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<void>;
}

@injectable()
export class ReportTicketComparativeRemoteDataSourceImpl implements ReportTicketComparativeRemoteDataSource {
    tableName: string = 'reportTickets/aggregate/comparative';
    baseUrlExportHtml: string = 'reportTickets/aggregate/comparative/html';

    async get(
        period: { startDate: string; endDate: string },
        comparePeriod: { compareStartDate: string; compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<ReportTicketComparativeEntity> {
        return new Promise<ReportTicketComparativeEntity>(async (resolve, reject) => {
            try {
                let url = `${this.tableName}?startDate=${period.startDate}&endDate=${period.endDate}&compareStartDate=${comparePeriod.compareStartDate}&compareEndDate=${comparePeriod.compareEndDate}`;
                if (filters?.idClient) {
                    url += `&idClient=${filters.idClient}`;
                }
                if (filters?.idContact) {
                    url += `&idContact=${filters.idContact}`;
                }
                if (filters?.idSector) {
                    url += `&idSector=${filters.idSector}`;
                }
                if (filters?.idUser) {
                    url += `&idUser=${filters.idUser}`;
                }
                if (filters?.idDescriptionStatic) {
                    url += `&idDescriptionStatic=${filters.idDescriptionStatic}`;
                }
                const response = await api.get(url);
                const report = ReportTicketComparativeEntity.fromJson(response.data);
                return resolve(report);
            } catch (error) {
                return reject(parseServerError(error));
            }
        });
    }

    async exportHtml(
        period: { startDate: string, endDate: string },
        comparePeriod: { compareStartDate: string, compareEndDate: string },
        filters?: ReportEntityFilters
    ): Promise<void> {
        return new Promise<void>(async (resolve, reject) => {
            try {
                let url = `${this.baseUrlExportHtml}?startDate=${period.startDate}&endDate=${period.endDate}&compareStartDate=${comparePeriod.compareStartDate}&compareEndDate=${comparePeriod.compareEndDate}`;
                if (filters?.idClient) {
                    url += `&idClient=${filters.idClient}`;
                }
                if (filters?.idContact) {
                    url += `&idContact=${filters.idContact}`;
                }
                if (filters?.idSector) {
                    url += `&idSector=${filters.idSector}`;
                }
                if (filters?.idUser) {
                    url += `&idUser=${filters.idUser}`;
                }
                if (filters?.idDescriptionStatic) {
                    url += `&idDescriptionStatic=${filters.idDescriptionStatic}`;
                }
                const response = await api.get(url, {responseType: 'blob'});
                const file = new Blob([response.data], {type: 'text/html;charset=utf-8'});
                const fileURL = URL.createObjectURL(file);
                openFileInNewTab(file, 'Carregando relatório...');
                downloadFile(fileURL, `relatório_comparativo_${period.startDate}-${period.endDate}.html`);
                return resolve();
            } catch (error) {
                await processBlobErrorResponse(error);
                return reject(parseServerError(error));
            }
        });
    }
}
